import { addStyles as addButtonStyles } from "@collectivehealth/dls-button";
import backButtonTheme from "./back-button-theme.css";

addButtonStyles([
  {
    attributeName: "theme",
    attributeValue: "back-button-theme",
    className: backButtonTheme.locals.backButton,
    styles: backButtonTheme.toString(),
    variations: {
      pressed: backButtonTheme.locals.pressed
    }
  }
]);
